import { useParams } from 'react-router'

export const useRequiredParams = <T extends Record<string, string>>() => useParams() as T
